import { ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export default ({ palette, typography }: ComposedTheme) => ({
  header: {
    padding: '1px 20px',
    cursor: 'pointer',
    color: palette.text.dark,
    lineHeight: '30px',
    fontFamily: typography.text.fontFamily,
    fontSize: 16,
    fontWeight: typography.text.fontWeight,
    outlineStyle: `${palette.focus.normal} solid 1px`,
  },
  content: {
    lineHeight: '24px',
    color: palette.grey.G600,
    size: 14,
    fontFamily: typography.text.fontFamily,
    fontWeight: 400,
  },
  icon: {
    display: 'none',
  },
  transition: {
    transitionDuration: '.25s',
    transitionTimingFunction: 'cubic-bezier(0.5, 1, 0.89, 1)',
    transitionDelay: '0s',
  },
  parentSection: {
    '& h3': {
      backgroundColor: '#c8dffc',
      margin: '0 0 10px 0',
    },
  },
  nestedSection: {
    '& h3': {
      backgroundColor: palette.primary.light,
      paddingLeft: 35,
      margin: '0 0 10px 0',
    },
    '& article': {
      padding: '0 0 10px 56px',
    },
  },
});
